export const initialSearchState = {
  searchValue: '',
  isFuzzy: true,
};

export default (state, action) => {
  switch (action.type) {
    case 'SEARCH_INITIALIZE':
      return {
        ...state,
        ...action.state,
      };
    case 'SEARCH_SET_VALUE':
      return {
        ...state,
        searchValue: action.searchValue,
      };
    case 'SEARCH_SET_IS_FUZZY':
      return {
        ...state,
        isFuzzy: action.isFuzzy,
      };
    default:
      return { ...state };
  }
};
